import { types } from 'mobx-state-tree';

import { 
    Address, 
    partiallyUpdateModel,
} from '../definitions/Common';
import CoverageAmountValues from '../definitions/CoverageAmountValues';
import DisabilityCoverageAmountValues from '../definitions/DisabilityCoverageAmountValues';
import {
    InsLifeWizardFormTypes,
    InsLifeWizardInsuranceTypes,
} from '../definitions/InsuranceTypeValues';

import Applicant from './Applicant';


const Journey = types
    .model('Journey', {
        // Configuration Fields
        providerId: types.maybeNull(types.string),
        formType: types.maybeNull(types.enumeration(Object.values(InsLifeWizardFormTypes))),
        insuranceType: types.maybeNull(types.enumeration(Object.values(InsLifeWizardInsuranceTypes))),

        // Common Fields
        applicant: types.maybeNull(Applicant),
        wantsBundledQuote: types.maybeNull(types.boolean),
        wantsEmailUpdates: types.maybeNull(types.boolean),

        // Standard Coverage Fields
        coverageAmount: types.maybeNull(types.enumeration(Object.values(CoverageAmountValues))),
        isJointPolicy: types.maybeNull(types.boolean),
        jointApplicant: types.maybeNull(Applicant),

        // Disability Coverage Fields
        disabilityCoverageAmount: types.maybeNull(
            // Can't use types.enumeration here because it expects all values to be strings
            // but these values are in number format, with one option having a string value
            types.refinement(
                types.union(
                    types.string,
                    types.number,
                ),
                value => DisabilityCoverageAmountValues.includes(value),
            ),
        ),
        
        // Group Coverage Fields
        companyName: types.maybeNull(types.string),   
        businessAddress: types.maybeNull(Address),
        numberOfEmployees: types.maybeNull(types.number),
    })
    .actions(self => ({
        update(snapshot) {
            partiallyUpdateModel(self, snapshot);
        },
    }));

export default Journey;
